import { Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ControlContainer, NgForm, NgModelGroup } from '@angular/forms';
import * as _ from 'lodash';
import { SerieEscolarService } from 'src/app/services/serie-escolar/serie-escolar.service';
import { SerieEscolar } from 'src/app/core/serie-escolar';

@Component({
  selector: 'combo-serie-escolar',
  templateUrl: './combo-serie-escolar.component.html',
  styleUrls: ['./combo-serie-escolar.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class ComboSerieEscolarComponent implements OnInit {

  @ViewChild('comboSerieEscolar', {static: false}) comboSerieEscolar;

  @Input() showDisplayId;
  @Input() obrigatorio;
  @Input() selecionado;
  @Input() desabilitado;

  @Output() valorChange = new EventEmitter();

  dados = [];
  data: any = {};

  constructor(private serieEscolarService: SerieEscolarService) {
  }

  ngOnInit(): void {
    this.data = Date.now();

    // Carrega séries escolares dinamicamente do serviço
    this.serieEscolarService.getAll().subscribe((series: SerieEscolar[]) => {
      this.dados = series;
      this.preencherCombo();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.preencherCombo();
  }

  private preencherCombo(){
    if (this.selecionado && this.dados.length) {
      if (typeof this.selecionado === 'number' || typeof this.selecionado === 'string') {
        this.selecionado = _.find(this.dados, { id: this.selecionado});
      }
    }
  }

  onValorChange(registro: any) {
    this.valorChange.emit(registro);
    this.preencherCombo();
  }

}
